import ENV from "config/Env";
import { backendQueryKey, localQueryKey } from "hooks/useTypedQuery";

import type { Appointment, Checklist, SNOOZE_DEPARTMENTS, SNOOZE_STATUSES, SNOOZE_TYPES, Snooze, Tag } from "models";
import type { LEAD_TYPES } from "modules/LeadsDashboard";
import type { PossibleQuestionStatusOptions } from "modules/LeadsDashboard/hooks";
import type { PAGE_SIZE } from "utils/common";
import type { PaginatedItems } from "utils/paginatedItems";

export type LeadsCarsFilter = {
  page: number;
  date_from: Date | null;
  date_to: Date | null;
  dealer_ids: number[];
  location_ids: number[];
  is_lease_company: boolean | null;
  search_term: string;
  page_size: PAGE_SIZE;
};

export type LeadsNotSnoozedFilters = {
  customer_approved: boolean;
  page: number;
  date_from: Date | null;
  date_to: Date | null;
  dealer_ids: number[];
  location_ids: number[];
  is_lease_company: boolean | null;
  search_term: string;
  interventions: boolean;
  statuses: PossibleQuestionStatusOptions[] | null;
  questions: number[] | null;
  tags: number[] | null;
  page_size: PAGE_SIZE;
};

export type LeadsSnoozedFilters = {
  customer_approved: boolean;
  page: number;
  appointment_date_from: Date | null;
  appointment_date_to: Date | null;
  snooze_date_from: Date | null;
  snooze_date_to: Date | null;
  dealer_ids: number[];
  location_ids: number[];
  is_lease_company: boolean | null;
  search_term: string;
  interventions: boolean;
  statuses: PossibleQuestionStatusOptions[] | null;
  questions: number[] | null;
  tags: number[] | null;
  snooze_department_id: SNOOZE_DEPARTMENTS | null;
  snooze_status_id: SNOOZE_STATUSES | null;
  snooze_type_id: SNOOZE_TYPES | null;
  last_customer_ok_is_me: boolean;
  updated_on_from: Date | null;
  updated_on_to: Date | null;
  page_size: PAGE_SIZE;
};

const component = "LeadsDashboard";

export const LeadsQueryKeys = {
  selectedLeadType: localQueryKey<LEAD_TYPES>({ component, data: "selectedLeadType" }),
  carsFilters: localQueryKey<LeadsCarsFilter>({ component, data: "carsFilters" }),
  snoozedFilters: localQueryKey<LeadsSnoozedFilters>({ component, data: "snoozedFilters" }),
  notSnoozedFilters: localQueryKey<LeadsNotSnoozedFilters>({ component, data: "notSnoozedFilters" }),
  tags: backendQueryKey<Tag[]>({ component, baseUrl: ENV.systemBaseURL, endpoint: "/tags/list" }),
  listCars: backendQueryKey<PaginatedItems<Appointment>>({ component, baseUrl: ENV.appointmentBaseURL, endpoint: "/leads/cars" }),
  listSnoozed: backendQueryKey<PaginatedItems<Snooze>>({ component, baseUrl: ENV.appointmentBaseURL, endpoint: "/leads/snoozed" }),
  checklists: backendQueryKey<Checklist[]>({ component, baseUrl: ENV.dealerBaseURL, endpoint: "/checklists/list" }),
  listNotSnoozed: backendQueryKey<PaginatedItems<Snooze>>({ component, baseUrl: ENV.appointmentBaseURL, endpoint: "/leads/not_snoozed" })
};
